import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AppError, AppMessage, IAppNotification } from '../../models';


export const NotificationsActions = createActionGroup({
  source: 'NotificationsEvents',
  events: {
    'Notification Occured': props<{ notification: IAppNotification }>(),
    'Error Occured': props<{ error: AppError }>(),
    'Message Occured': props<{ message: AppMessage }>(),

    'Dismissed': props<{ id: string }>(),
    'DismissAll': emptyProps(),

    'Toggle': emptyProps(),
    
    'Reset': emptyProps(),
  },
});